import { usePathname, useRouter } from 'next/navigation';

import type { ColumnData } from '@/components/table/SortableTableHead';
import { SortableTableHead } from '@/components/table/SortableTableHead';

import { VisibleToLabel } from '../table-head/VisibleToLabel';

interface Props {
  sort: string | undefined;
  canRestrictVisibility: boolean;
  selected: boolean;
}

const columnData: ColumnData[] = [
  {
    id: 'filename',
    numeric: false,
    label: 'Name',
    defaultOrderDirection: 'asc',
  },
  { id: 'locked' },
  {
    id: 'lastModified',
    numeric: false,
    label: 'Last Modified',
  },
  {
    id: 'visibility',
    numeric: false,
    label: <VisibleToLabel />,
    cellPadding: 'dense',
    unsortable: true,
  },
  { id: 'options' },
];

export const FileManagerTableHead = ({
  sort,
  canRestrictVisibility,
  selected,
}: Props) => {
  const pathname = usePathname();
  const router = useRouter();

  const columns = canRestrictVisibility
    ? columnData
    : columnData.filter((column) => column.id !== 'visibility');

  return (
    <SortableTableHead
      orderBy={sort}
      onChangeOrderBy={(order) => {
        const params = new URLSearchParams();
        params.set('sort', order);
        router.replace(`${pathname}?${params.toString()}`);
      }}
      columns={columns}
      selected={selected}
    />
  );
};
